(function () {
  "use strict";

  brandResolver.$inject = ['$q', 'brandResource', 'Validation', 'refreshSession', 'Auth'];
  angular
    .module('branding')
    .factory('brandResolver', brandResolver);

  function brandResolver($q, brandResource, Validation, refreshSession, Auth) {

    return function () {

      var deferred = $q.defer();

      var authorize = function () {
          return Auth.getRolePromise();
        },

        loadBranding = function () {
          return brandResource.load().$promise;
        },

        refresh = function () {
          return refreshSession.resource().$promise;
        };

      if (!Validation.validate()) {
        deferred.reject(false);
        return deferred.promise;
      }

      $q.all([authorize().then(loadBranding), refresh()])
        .then(function (result) {
          deferred.resolve(result[0]);
        }, function (reason) {
          deferred.reject(reason);
        });

      return deferred.promise;
    };
  }

})();

